import { createContext, Dispatch, SetStateAction, useContext } from 'react';

import { WhatsappVerificationStep } from '../types';

type WhatsappVerificationContext = {
  currentStep: WhatsappVerificationStep;
  stepHistory: WhatsappVerificationStep[];
  nextStep: () => void;
  previousStep: () => void;
  setCurrentStep: Dispatch<SetStateAction<WhatsappVerificationStep>>;
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
  resendOTPCountdown: number;
  setResendOTPCountdown: Dispatch<SetStateAction<number>>;
};

export const WhatsappVerificationContext = createContext<
  WhatsappVerificationContext | undefined
>(undefined);

export const useWhatsappVerificationContext = () => {
  const context = useContext(WhatsappVerificationContext);
  if (!context) {
    throw new Error(
      'useWhatsappVerificationContext must be used within WhatsappVerificationModal'
    );
  }
  return context;
};
